export const verificaTipoDaVariavel = (type: string, ...parametros: any[]) => {
  return parametros.reduce((acc: boolean, curr) => {
    if (!acc) return acc;

    const isString = typeof curr === type;

    return acc === isString;
  }, true);
};
